var map = {
	"./A型血@2x.png": "bcf6",
	"./EB病毒感染@2x.png": "a307",
	"./HBsAg阳性@2x.png": "a20e",
	"./HPV感染@2x.png": "3776",
	"./ICVD风险年龄@2x.png": "c432",
	"./一级亲属结直肠 癌家族史@2x.png": "706f",
	"./一级亲属膀胱癌家族史@2x.png": "78c5",
	"./一级亲属食管癌 家族史@2x.png": "61f2",
	"./上消化道病史@2x.png": "a4bf",
	"./丙肝病史@2x.png": "c8efe",
	"./乙肝病史@2x.png": "dd42",
	"./乳腺病史@2x.png": "bdcf",
	"./乳腺癌、卵巢癌 家族史@2x.png": "3929",
	"./二级亲属结直肠 癌家族史@2x.png": "1ae7",
	"./体力活动不足@2x.png": "a750",
	"./便潜血阳性@2x.png": "218a",
	"./初潮较早@2x.png": "f398",
	"./动物性饱和脂肪 摄入过量@2x.png": "a260",
	"./吸烟@2x.png": "d01e",
	"./吸烟指数中度@2x.png": "5ac3",
	"./吸烟指数极高@2x.png": "5ac36",
	"./吸烟指数较低@2x.png": "5ac36b",
	"./吸烟指数较高@2x.png": "5ac36bd",
	"./吸烟斗烟@2x.png": "8fef",
	"./多个性伙伴@2x.png": "8ea1",
	"./多次人工流产@2x.png": "7050",
	"./子宫颈癌家族史@2x.png": "a304",
	"./少次人工流产@2x.png": "fff2",
	"./居室接触烟雾@2x.png": "e9c1",
	"./已戒烟@2x.png": "7e96",
	"./常吃油炸食品@2x.png": "8a69",
	"./常吃热烫食物@2x.png": "ec95",
	"./常吃腌制食物@2x.png": "7d7f",
	"./幽门螺旋杆菌感染@2x.png": "e1ec",
	"./性生活较早@2x.png": "fc21",
	"./性生活过早@2x.png": "8354",
	"./总胆固醇偏高@2x.png": "ff4d",
	"./恶性肿瘤@2x.png": "a414",
	"./慢性便秘@2x.png": "ae95",
	"./慢性支气管炎@2x.png": "370c",
	"./慢性肠炎@2x.png": "f1a6",
	"./慢性阑尾炎@2x.png": "8732",
	"./接触有害物质@2x.png": "7135",
	"./接触煤烟或焦油@2x.png": "95e2",
	"./接触石棉@2x.png": "d4db",
	"./接触硅粉尘@2x.png": "b383",
	"./接触空气污染@2x.png": "89ea",
	"./收缩压偏高@2x.png": "4186",
	"./收缩压综合风险@2x.png": "714b",
	"./日饮酒过量@2x.png": "2617",
	"./未育@2x.png": "6a7e",
	"./果蔬摄入不足@2x.png": "fed1",
	"./母亲高血压家族史@2x.png": "f9a3",
	"./每周运动不足@2x.png": "429a",
	"./消化性溃疡@2x.png": "3c4f",
	"./消化道癌症家族史@2x.png": "667a",
	"./父亲高血压家族史@2x.png": "cc48",
	"./父母糖尿病家族史@2x.png": "da35",
	"./甘油三酯偏高@2x.png": "9434",
	"./生育次数较少@2x.png": "9d7d",
	"./生育较晚@2x.png": "9fdf",
	"./盐分摄入过量@2x.png": "f4a7",
	"./空腹血糖调节受损@2x.png": "c74a",
	"./糖尿病@2x.png": "6d1a",
	"./糖尿病史@2x.png": "c461",
	"./绝经较早@2x.png": "8e73",
	"./肉类摄入过量@2x.png": "0687",
	"./肝癌家族史@2x.png": "e557",
	"./肠息肉@2x.png": "6c42",
	"./肥胖@2x.png": "9a53",
	"./肺炎病史@2x.png": "3096",
	"./肺癌家族史@2x.png": "1f52",
	"./肺结核史@2x.png": "5571",
	"./肿瘤家族史@2x.png": "93b8",
	"./胃息肉@2x.png": "5fe2",
	"./胃癌家族史@2x.png": "6bd6",
	"./胃癌风险年龄@2x.png": "bbdd",
	"./胆囊切除@2x.png": "f94d",
	"./腰围偏大@2x.png": "3a79",
	"./舒张压综合风险@2x.png": "1329",
	"./萎缩性胃炎@2x.png": "3c67",
	"./被动吸烟@2x.png": "10bc",
	"./被动吸烟女性 @2x.png": "c513",
	"./超重@2x.png": "cae9",
	"./过量饮酒@2x.png": "ce67",
	"./食用黄曲霉毒素@2x.png": "ed92",
	"./食管癌风险年龄@2x.png": "696e",
	"./饮水污染@2x.png": "f765",
	"./饮酒@2x.png": "9234",
	"./高血压@2x.png": "45bd",
	"./高龄生育@2x.png": "5281",
	"./黏膜便血@2x.png": "2865",
	"./鼻咽疾病史@2x.png": "4af3",
	"./鼻咽癌家族史@2x.png": "f6ee"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ec0";